const SelectedRecordListStore = {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    addSlug(state, slug) {
      if (!state.list.includes(slug)) {
        state.list.push(slug);
      }
    },
    removeSlug(state, slug) {
      state.list = state.list.filter((item) => item !== slug);
    },
    clear(state) {
      state.list = [];
    }
  },
  actions: {},
  getters: {}
};

export default SelectedRecordListStore;
